import { render, staticRenderFns } from "./product-center.vue?vue&type=template&id=0e505347&scoped=true"
import script from "./product-center.vue?vue&type=script&lang=js"
export * from "./product-center.vue?vue&type=script&lang=js"
import style0 from "./product-center.vue?vue&type=style&index=0&id=0e505347&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e505347",
  null
  
)

export default component.exports